module.exports = __webpack_public_path__ + "img/partner-urbanair.2551ec8c.png";